import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from './DataService';
import { IEntityMetaData } from '../_models/IEntityMetaData';
import { ApiRepository } from '../repositories/ApiRepository';
import { environment } from '@app/../environments/environment';
import { EntityConstructor } from './DependecyInjection.provider';
import { EntityBase } from '../_models/EntityBase';
import { MatwinsVariablesService } from './matwinsVariables.service';
import { ResponseHandlerService } from './ResponseHandlerService';
import { LookupService } from './LookupService';
import { BrowserIdService } from './browser-id.service';


@Injectable({ providedIn: 'root' })
export class EntityServiceProvider {
  private services = new Map<string, DataService<any>>();

  protected browserIdService = inject(BrowserIdService); 
  constructor(private http: HttpClient,
    private httpVariablesService: MatwinsVariablesService,
    private responseHandler: ResponseHandlerService, private lookupService: LookupService) { }

  register<T extends EntityBase>(entityType: EntityConstructor<T>, entityMetaData: IEntityMetaData) {
    const entityName = entityMetaData.EntityName;
    const repo = new ApiRepository<T>(this.http, this.httpVariablesService, this.responseHandler, this.browserIdService);
    repo.setMetaData(entityMetaData);
    repo.setBaseUrl(`${environment.apiBaseUrl}/api`)

    const dataService = new DataService<T>(repo, this.lookupService);
    this.services.set(entityName, dataService);
  }

  get<T extends EntityBase>(entityType: EntityConstructor<T>): DataService<T> {
    const service = this.services.get(entityType.name);
    if (!service) {
      throw new Error(`Service not registered for ${entityType.name}`);
    }
    return service as DataService<T>;
  }

  getByMetaData<T extends EntityBase>(metaData: IEntityMetaData): DataService<T> {
    const service = this.services.get(metaData.EntityName);
    if (!service) {
      throw new Error(`Service not registered for ${metaData.EntityName}`);
    }
    return service as DataService<T>;
  }
}

